import React from 'react';
import { useNavigate } from 'react-router-dom';

const Manuscripts = () => {
  const navigate = useNavigate();

  const manuscripts = [
    {
      icon: '॥',
      title: 'Bhagavad Gita',
      sanskritTitle: 'श्रीमद्भगवद्गीता',
      description: 'The eternal dialogue between Krishna and Arjuna, revealing the paths of action, devotion, and knowledge.',
      link: '/gita',
      onClick: () => navigate('/gita')
    },
    {
      icon: 'ॐ',
      title: 'The Vedas',
      sanskritTitle: 'वेदाः',
      description: 'The foundational hymns of Sanatana Dharma, containing the primordial sounds of creation and cosmic order.',
      link: '/vedas',
      onClick: () => alert('Vedas section coming soon!')
    },
    {
      icon: '☉',
      title: 'Upanishads',
      sanskritTitle: 'उपनिषद्',
      description: 'The philosophical culmination of Vedic thought, exploring the nature of reality, consciousness, and liberation.',
      link: '/upanishads',
      onClick: () => alert('Upanishads section coming soon!')
    }
  ];

  return (
    <section className="manuscripts" id="manuscripts">
      <div className="section-header">
        <h2>Sacred Manuscripts</h2>
        <div className="section-divider"></div>
      </div>
      
      <div className="manuscript-grid">
        {manuscripts.map((manuscript, index) => (
          <div key={index} className="manuscript-card" onClick={manuscript.onClick}>
            <div className="card-icon">{manuscript.icon}</div>
            <h3 className="manuscript-title">{manuscript.title}</h3>
            <p className="sanskrit-title">{manuscript.sanskritTitle}</p>
            <p className="manuscript-description">
              {manuscript.description}
            </p>
            <a href={manuscript.link} className="enter-btn" onClick={(e) => e.preventDefault()}>
              ENTER <span>→</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Manuscripts; 